/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetPipeSeriesOptions, GetPipeSeriesResponses } from '../types/GetPipeSeries'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /pipe-series/}
 */
export function getPipeSeries<ThrowOnError extends boolean = true>(options: Options<GetPipeSeriesOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetPipeSeriesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/pipe-series/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetPipeSeriesResponses, ThrowOnError>>)
}
